import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Header from './Header';
import { useAuth } from '@/context/AuthContext';

export function PublicLayout() {
    return (
        <div className="min-h-screen bg-ink text-white">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 py-10"><Outlet /></main>
            <footer className="border-hairline-b mt-20 border-t border-zinc-800/60">
                <div className="max-w-[1400px] mx-auto px-6 py-10 flex flex-col md:flex-row justify-between gap-6 text-zinc-500 font-mono-data text-xs uppercase">
                    <div>Locals Headquarters Pty Ltd · Apparel Portal · AUD</div>
                    <div>Fulfilment: 6–8 weeks · Embroidery included</div>
                </div>
            </footer>
        </div>
    );
}

export function ProtectedLayout({ adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono-data">Loading…</div>;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
    return <PublicLayout />;
}
